import React from 'react';
import { Table } from 'reactstrap';

const EvaluatorGroupTable = ({ evaluatorGroups = [], totalMapping = 13 }) => {
  const renderStatus = (status, hasAction) => {
    if (hasAction) {
      return (
        <button
          type="button"
          className="p360-action-btn"
          style={{ width: '30px', height: '30px' }}
          title="Lihat Detail Penilaian"
        >
          <i className="uil uil-eye"></i>
        </button>
      );
    }

    if (!status || status === '-') {
      return <span>-</span>;
    }

    const statusLower = status.toLowerCase();
    return (
      <span className={`p360-status-badge ${statusLower === 'submitted' ? 'submitted' : 'draft'}`}>
        {status}
      </span>
    );
  };

  return (
    <div className="mb-4">
      {/* Section Header */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div className="p360-evaluator-section-title">
          {/* <i className="uil uil-users-alt text-primary" style={{ fontSize: '1.2rem' }}></i> */}
          <span>Rincian Poin &amp; Skor Per-Penilai Individual</span>
        </div>
        <div className="p360-evaluator-mapping-info">
          <i className="uil uil-info-circle text-muted"></i>
          <span>Total Mapping: {totalMapping} Penilai</span>
        </div>
      </div>

      {/* Evaluator Groups */}
      {evaluatorGroups.map((group) => {
        const isAtasan = group.groupId === 'atasan';
        const groupHeaderClass = isAtasan ? 'p360-group-header atasan' : 'p360-group-header rekan';
        const weightPillClass = isAtasan ? 'p360-weight-pill blue' : 'p360-weight-pill green';

        return (
          <div key={group.groupId} className="p360-group-card">
            {/* Group Header */}
            <div className={groupHeaderClass}>
              <span>{group.groupTitle}</span>
              <span className={weightPillClass}>
                Bobot Peran: {group.bobotPercent}%
              </span>
            </div>

            {/* Group Table */}
            <Table responsive className="p360-table align-middle mb-0">
              <thead>
                <tr>
                  <th className="text-center" style={{ width: '45px' }}>No</th>
                  <th style={{ minWidth: '220px' }}>Penilai (Evaluator)</th>
                  <th style={{ minWidth: '240px' }}>Jabatan Penilai</th>
                  <th className="text-center" style={{ minWidth: '130px' }}>Skor Total Jawaban</th>
                  <th className="text-center" style={{ minWidth: '120px' }}>Skor Maksimal</th>
                  <th className="text-center" style={{ minWidth: '150px' }}>Skor Akhir (Skala 100)</th>
                  <th className="text-center" style={{ minWidth: '100px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {group.evaluators.map((evaluator) => (
                  <tr key={evaluator.no}>
                    <td className="text-center text-muted" style={{ fontWeight: 500 }}>
                      {evaluator.no}
                    </td>
                    <td style={{ fontWeight: 600, color: '#1e293b' }}>
                      {evaluator.nama}
                    </td>
                    <td className="text-muted small">
                      {evaluator.jabatan}
                    </td>
                    <td className="text-center" style={{ fontWeight: 500 }}>
                      {evaluator.skorTotal}
                    </td>
                    <td className="text-center" style={{ fontWeight: 500 }}>
                      {evaluator.skorMaksimal}
                    </td>
                    <td className="text-center" style={{ fontWeight: 600 }}>
                      {evaluator.skorAkhir}
                    </td>
                    <td className="text-center">
                      {renderStatus(evaluator.status, evaluator.hasAction)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* Summary Footer Bar */}
            <div className="p360-group-summary-footer">
              <span className="p360-group-summary-label">
                {isAtasan ? 'Rata-Rata Kelompok Atasan:' : 'Rata-Rata Kelompok Rekan / Sejawat:'}
              </span>
              <div className="p360-group-summary-value-box">
                {group.averageScore}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EvaluatorGroupTable;
